<template>
  <div>
    <fieldset>
      <legend>
        <slot />
      </legend>
      <div v-for="(item, index) in props.config" :key="index">
        <slot
          name="radio-wrapper"
          :item="item"
          :index="index"
          :radio-wrapper-id="
            getRadioButtonGroupElementId(index, 'radio-wrapper')
          "
        />
        <Teleport
          v-if="showEl"
          :to="disabled ? null : getTeleportToSelector(index, 'radio-wrapper')"
          :disabled="disabled"
        >
          <gsp-radio
            :ref="(el) => (fieldRef[index] = el)"
            :value="item.radioButtonValue"
            :checked="isEqual(value, item.radioButtonValue)"
            @change="radioButtonChanged($event, item.radioButtonValue)"
            :disabled="item.disabled"
            class="vm-flex vm-items-start vm-mr-6"
          >
            <span v-if="item.radioButtonLabel" v-html="item.radioButtonLabel" />
            <span v-else v-html-t="item.radioButtonLabelT" />
          </gsp-radio>
        </Teleport>
      </div>
      <gsp-text-field-error-message>
        {{ errorMessage }}
      </gsp-text-field-error-message>
    </fieldset>
  </div>
</template>

<script>
let instanceCount = 0;
</script>

<script setup>
import { ref, useSlots } from "vue";
import initValidationField, {
  fieldProps,
  fieldEmits,
} from "~/composables/validation-field";
import isEqual from "lodash/isEqual";
import showElOnMounted from "~/composables/show-el-on-mounted";
import { getAppMountedEl } from "~/utils/miscellaneous";

const instanceId = `radio-${instanceCount++}`;

const slots = useSlots();

const disabled = ref(!slots["radio-wrapper"]);

const showEl = showElOnMounted();

const props = defineProps({
  ...fieldProps,
  config: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits({
  ...fieldEmits,
});

const fieldRef = ref([]);

const appMountedEl = getAppMountedEl();

const { value, errorMessage, validate } = initValidationField({
  props,
  emit,
  fieldRef,
});

function radioButtonChanged(e, radioButtonValue) {
  if (!e.target.checked) return;

  value.value = radioButtonValue;
  validate();
}

function getRadioButtonGroupElementId(index, type) {
  return `${instanceId}-${type}-${index}`;
}

function getTeleportToSelector(index, type) {
  return appMountedEl.querySelector(
    `[data-radio-wrapper-id="${getRadioButtonGroupElementId(index, type)}"]`
  );
}
</script>
